const useQueryParams = (): URLSearchParams =>
  new URLSearchParams(window.location.search);

export default useQueryParams;
